module.exports = __webpack_public_path__ + "src/assets/img/m-item2.a762b242.png";